var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-10 d-flex flex-row justify-center"},[_c('Card',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }